<template>
  <v-dialog
    v-model="dialog"
    width="448"
    open-on-focus
    no-click-animation
    persistent
    content-class="new-sequence-exercise-dialog"
    @click:outside="onClickOutside"
    @keydown="onKeydown"
  >
    <v-card elevation="0">
      <v-form
        ref="form"
        class="new-sequence-exercise-form"
        @submit.prevent="onSubmit"
      >
        <div class="new-sequence-exercise-form-body">
          <v-toolbar flat height="76">
            <v-toolbar-title class="new-sequence-exercise-toolbar-title"
              >{{ editedExercise.exercise ? 'Edit' : 'New' }}
              {{
                tenantTexts.sequenceExerciseDialog.activityLabel
              }}</v-toolbar-title
            >
            <v-spacer></v-spacer>
            <v-btn
              color="accent"
              rounded
              elevation="0"
              v-if="createNewExerciseDefinition"
              @click="$emit('show-create-new-exercise-dialog')"
            >
              Create new
            </v-btn>
            <v-btn color="accent" icon tile @click="closeDialog">
              <v-icon size="24">mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-container class="new-sequence-exercise-card-container">
            <v-text-field
              :value="searchValue"
              class="bh-input-pill rounded-pill"
              color="accent"
              height="48px"
              placeholder="Search for activities"
              filled
              clearable
              hide-details
              @input="onSearch('query', $event)"
              @click:clear="clearSearch"
              @click:append="runSearch"
              @keydown.enter="runSearch"
            >
              <template v-slot:append>
                <v-progress-circular
                  v-if="exerciseDefinitionsLoading"
                  size="16"
                  width="2"
                  color="info"
                  indeterminate
                ></v-progress-circular>
                <v-icon v-else>bhi-loupe</v-icon>
              </template>
            </v-text-field>
            <div class="new-sequence-exercise__types mt-2 mb-2">
              <v-btn
                icon
                text
                @click="filterType('EXERCISE', !filterExercise)"
                :class="filterExercise ? 'active' : ''"
              >
                <v-icon size="24">bhi-exercise</v-icon>
              </v-btn>
              <v-btn
                icon
                text
                @click="filterType('SERIES', !filterSeries)"
                :class="filterSeries ? 'active' : ''"
              >
                <v-icon size="24">bhi-list</v-icon>
              </v-btn>
              <v-btn
                icon
                @click="filterType('ACTIVITY', !filterActivity)"
                :class="filterActivity ? 'active' : ''"
              >
                <v-icon size="24">bhi-activity</v-icon>
              </v-btn>
            </div>
            <main-user-table
              :headers="headers"
              :items="computedExerciseDefinitions"
              :items-per-page="exerciseDefinitionsPagination.pageSize"
              :server-items-length="
                exerciseDefinitionsPagination.totalCount || -1
              "
              :page="queryParams.page"
              :row-component="'exercise-definition-table-row'"
              @choose-exercise="chooseExerciseDefinition"
              @preview-exercise="previewExerciseDefinition"
              @action:get-data="data => getDataAction({ ...data }, false)"
            />
          </v-container>
        </div>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import MainUserTable from '@/components/tables/MainUserTable'
import RouterMixin from '@/mixins/router'
import { debounce } from '@/helpers/debounce'
import TenantTextsMixin from '@/mixins/tenantTexts'

const emptyForm = {}

export default {
  name: 'SequenceExerciseDialog',
  components: {
    MainUserTable,
  },
  mixins: [RouterMixin, TenantTextsMixin],
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    resource: {
      type: [Boolean, Object],
      default: false,
    },
    exerciseResource: {
      type: [Boolean, Object, null],
      default: false,
    },
    day: {
      type: [Boolean, Number, String],
      default: false,
    },
    editedExercise: {
      type: [Boolean, Object],
      default: false,
    },
    getResource: {
      type: Function,
      default: () => null,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    exerciseDefinitions: {
      type: Array,
      default: () => [],
    },
    exerciseDefinitionsLoading: {
      type: Boolean,
      default: false,
    },
    enabledNotes: {
      type: Boolean,
      default: false,
    },
    createNewExerciseDefinition: {
      type: Boolean,
      default: true,
    },
    getMimeTypes: {
      type: Function,
      default: () => null,
    },
    exerciseDefinitionsPagination: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      tab: null,
      dialog: false,
      newExerciseData: {
        date: null,
        title: '',
        description: '',
        media: null,
        currentMedia: null,
        additionalMedia: null,
        currentAdditionalMedia: null,
        mobileStaticMedia: null,
      },
      headers: [],
      showMlFilePickerDialog: false,
      resourceName: null,
      formIsValidCheck: false,
      uploadFile: [],
      searchValue: '',
      tabSingle: 0,
      singleParameters: {
        time: {
          status: false,
          value: null,
          label: 'Time',
          unit: 'min',
        },
        weight: {
          status: false,
          value: null,
          label: 'Weight',
          unit: 'kg',
        },
        repetitions: {
          status: false,
          value: null,
          label: 'Repetitions',
          unit: 'x',
        },
        sets: {
          status: false,
          value: null,
          label: 'Sets',
          unit: 'x',
        },
        restTimeBetweenSets: {
          status: false,
          value: null,
          label: 'Rest time between sets',
          unit: 'sec',
        },
        restTimeAfterExercise: {
          status: false,
          value: null,
          label: 'Rest time between repetitions',
          unit: 'sec',
        },
        distance: {
          status: false,
          value: null,
          label: 'Distance',
          unit: 'meters',
        },
      },
      alternativeExercises: false,
      searchedExerciseDefinitions: [],
      selectedExerciseDefinitions: [],
      alternativeExercisesList: [],
      showAlternativeExercisesDialog: false,
      filterSeries: false,
      filterExercise: false,
      filterActivity: false,
      multipleInputs: [],
      selectedFilterType: 'ACTIVITY',
    }
  },
  watch: {
    showDialog: function(val) {
      if (val) {
        this.dialog = true
        // set default filter at activities
        this.filterType(this.selectedFilterType, true)
      } else {
        this.dialog = false
      }
    },
    editedExercise: function(val) {
      if (this.dialog && this.editedExercise) {
        this.newExerciseData = { ...this.editedExercise }
        if (this.editedExercise.resourceId) {
          this.$emit('reload-resource', this.editedExercise.resourceId)
        }
        this.formIsValid()
      }
    },
  },
  mounted() {},
  computed: {
    computedExerciseDefinitions() {
      return this.exerciseDefinitions.map(item => {
        if (item.type == 'EXERCISE') {
          item.title = item.exercise.title
          item.description = item.exercise.description
          item.id = 'exercise__' + item.exercise.id + '__' + item.id
          item.media = item.exercise.media
          item.additionalMedia = item.exercise.additionalMedia
          item.mobileStaticMedia = item.exercise.mobileStaticMedia
        } else if (item.type == 'SERIES') {
          item.title = item.series.title
          item.description = item.series.description
          item.id = 'series__' + item.series.id + '__' + item.id
          item.media = item.series.media
          item.additionalMedia = item.series.additionalMedia
          item.mobileStaticMedia = item.series.mobileStaticMedia
        } else {
          item.title = item.activity.title
          item.description = item.activity.description
          item.id = 'activity__' + item.activity.id + '__' + item.id
          item.media = item.activity.media
          item.additionalMedia = item.activity.additionalMedia
          item.mobileStaticMedia = item.activity.mobileStaticMedia
        }
        return item
      })
    },
    singleParametersNames() {
      return Object.keys(this.singleParameters)
    },
    exercisesQuery() {
      let query = {}
      if (this.searchValue) query.query = this.searchValue
      if (this.filterSeries) query.type = 'SERIES'
      if (this.filterActivity) query.type = 'ACTIVITY'
      if (this.filterExercise) query.type = 'EXERCISE'
      return query
    },
  },
  methods: {
    async openBigImage() {
      if (this.exerciseResource.id) {
        this.$emit('show-bigger-image', {
          url: null,
          file: null,
          name: null,
          mlResourceUrl: null,
        }) // Show dialog while getting new s3 file url
        // await this.getResource({ id: this.exerciseResource.id })
      }
      const title =
        this.exerciseResource.title.replace(/[/\\?%*:|"<>]/g, '-') +
        '.' +
        this.exerciseResource.name
          .split('.')
          .pop()
          .trim()
          .toLowerCase()
      this.$emit('show-bigger-image', {
        url: this.exerciseResource.fileUrl,
        name: title || this.resourceName,
        file: this.exerciseResource.previewUrl,
        mlResourceUrl: this.exerciseResource.id,
      })
    },
    formIsValid() {
      if (this.newExerciseData?.title?.trim() != '')
        this.formIsValidCheck = true
      else this.formIsValidCheck = false
    },
    closeDialog() {
      this.dialog = false
      this.$emit('close-exercise-dialog')
    },
    onClickOutside() {
      this.closeDialog()
    },
    onKeydown(key) {
      if (key.code === 'Escape' && key.isTrusted) this.closeDialog()
    },
    onInput({ name, value }) {
      this.newExerciseData[name] = value
      this.formIsValid()
    },
    onSubmit() {
      if (this.day !== false) {
        this.newExerciseData.date = this.day
        this.newExerciseData.day = this.day
      }
      if (this.editedExercise)
        this.$emit('on-edit', { ...this.newExerciseData })
      else this.$emit('on-submit', { ...this.newExerciseData })
      this.closeDialog()
    },
    chooseExerciseDefinition(id, type) {
      this.$emit('on-choose-existing', id, type, this.day)
    },
    previewExerciseDefinition(id, type) {
      this.$emit('preview-exercise-definition', id, type)
    },
    getData(data = new URLSearchParams()) {
      data.set('type', this.selectedFilterType)

      if (this.dialog) {
        this.$emit('reload-exercises', data)
      }
    },
    onSearch(key, value) {
      this.searchValue = value
      debounce(
        () => {
          this.triggerQueryAction()
        },
        1000,
        'ExercisesFilters',
      )
    },
    triggerQueryAction() {
      let multipleInputs = []
      Object.keys(this.exercisesQuery).forEach(key => {
        multipleInputs.push({ key: key, value: this.exercisesQuery[key] })
      })
      this.$emit('search-on:multiple', multipleInputs)
    },
    onMultiple(key, value) {
      debounce(
        () => {
          this.triggerQueryAction()
        },
        1000,
        'ExercisesFilters',
      )
    },
    clearSearch() {
      this.searchValue = ''
      this.triggerQueryAction()
    },
    runSearch() {
      if (this.searchValue) this.triggerQueryAction()
    },
    nextStepSingle() {
      if (!Object.values(this.singleParameters).every(x => x.status === false))
        this.tabSingle++
      else {
        this.tabSingle = 1 // uglyfix: v-tabs-items when jumping from tab 0 to 2 in [0,1,2] layout will transition from left, instead of right side of dialog; this way we force proper animation flow
        setTimeout(() => {
          this.tabSingle = 2
        }, 10)
      }
    },
    prevStepSingle() {
      if (!Object.values(this.singleParameters).every(x => x.status === false))
        this.tabSingle--
      else {
        this.tabSingle = 1
        setTimeout(() => {
          this.tabSingle = 0
        }, 10)
      }
    },
    openSelectAlternativeExercisesDialog() {
      this.showAlternativeExercisesDialog = true
    },
    closeSelectAlternativeExercisesDialog() {
      this.showAlternativeExercisesDialog = false
      this.$emit('clear-timeout')
    },
    chosenAlternativeExercises(exercises) {
      this.alternativeExercisesList = exercises
    },
    filterType(name, value) {
      let type = ''
      if (value) type = name
      switch (name) {
        case 'EXERCISE':
          this.filterExercise = value
          this.filterSeries = false
          this.filterActivity = false
          this.onMultiple('type', type)
          this.selectedFilterType = 'EXERCISE'
          break
        case 'SERIES':
          this.filterSeries = value
          this.filterExercise = false
          this.filterActivity = false
          this.onMultiple('type', type)
          this.selectedFilterType = 'SERIES'
          break
        case 'ACTIVITY':
          this.filterActivity = value
          this.filterSeries = false
          this.filterExercise = false
          this.onMultiple('type', type)
          this.selectedFilterType = 'ACTIVITY'
          break
      }
    },
  },
}
</script>

<style lang="scss">
@import '@/styles/variables.scss';

.new-sequence-exercise {
  &-dialog {
    margin: $gutter;
    margin-left: auto;
    height: 100%;
    max-height: calc(100% - #{2 * $gutter}) !important;
    // looks little hacky
    > .v-card {
      width: 100%;
      height: 100%;
    }
  }
  &-form-body {
    height: 100%;
    display: flex;
    flex-direction: column;

    .v-toolbar {
      flex-grow: 0 !important;
    }
  }
  &-v-tabs-items {
    flex-grow: 1;
    overflow: auto;
    & > .v-window__container {
      height: 100%;
      & > .v-window-item {
        height: 100%;
      }
    }
  }
  &-toolbar-title {
    color: $bh-blue;
    font-size: 1.5715rem;
    font-weight: bold;
  }
  &__tab {
    height: 100%;
    background-color: $bh-blue--4;
    display: flex;
    flex-direction: column;
    & > .v-tabs-items {
      overflow: auto;
      flex-grow: 1;
      background-color: $bh-blue--4;
    }
    .v-input--switch {
      margin: 0;
    }
    .v-label {
      font-size: 12px;
      color: $bh-gray--2;
    }
  }
  &__dots {
    span {
      width: 16px;
      height: 16px;
      display: inline-block;
      border-radius: 50%;
      background-color: $bh-white;
      margin: 0 3px;
      transition-duration: 300ms;
      &.active {
        background-color: $bh-blue;
      }
    }
  }
  &-card {
    &-title {
      font-size: $font-size-root;
      color: $bh-blue;
      padding-left: 1.5 * $gutter;
      padding-right: 1.5 * $gutter;
    }
    &-container {
      padding-left: 1.5 * $gutter;
      padding-right: 1.5 * $gutter;
      display: flex;
      flex-direction: column;
      overflow: auto;
      .v-data-table__wrapper {
        overflow: unset;
      }
      .bh-input-pill {
        height: 48px !important;
        margin-bottom: 8px !important;
        width: auto;
        .v-input__slot {
          align-items: center;
          height: 48px;
          min-height: 0 !important;
          &::before,
          &::after {
            content: '';
            display: none;
          }
          .v-input__append-inner {
            align-self: center;
            margin-top: 0 !important;
          }
          .v-icon {
            color: $bh-blue;
          }
        }
      }
    }
    &-footer {
      padding: 1.5 * $gutter;
    }
  }
  &-file-button {
    margin-right: 10px;
    vertical-align: middle;
    .v-icon {
      &:first-child {
        padding-right: 10px;
      }
      &:last-child {
        padding-left: 10px;
      }
    }
  }
  &-file-details {
    display: inline-block;
    vertical-align: middle;
    img {
      width: 40px;
      height: 40px;
      display: inline-block;
      vertical-align: middle;
      object-fit: cover;
      margin-right: 10px;
      cursor: pointer;
    }
    .v-progress-circular {
      margin-right: 10px;
    }
    .v-icon {
      margin-left: 5px;
      padding: 4px;
    }
    span {
      cursor: default;
    }
  }
  &-form {
    background-color: $bh-blue--4;
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow: auto;

    &-body {
      ::v-deep .v-toolbar__content {
        padding-left: 1.5 * $gutter;
        padding-right: 1.5 * $gutter;
      }
    }
    &-col-left {
      padding-top: 0;
      padding-right: 0.25 * $gutter;
    }
    &-col-right {
      padding-top: 0;
      padding-left: 0.25 * $gutter;
    }
  }
  &__types {
    .v-btn {
      margin-right: 2px;
    }
    .v-btn.active {
      background: $bh-blue !important;
      .v-icon {
        &::before {
          color: $bh-white;
        }
      }
    }
  }
}
</style>
